(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Ticket', Ticket);

    Ticket.$inject = ['$resource', 'DateUtils'];

    function Ticket ($resource, DateUtils) {
        var resourceUrl =  'api/tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtins = DateUtils.convertDateTimeFromServer(data.dtins);
                        data.dtend = DateUtils.convertDateTimeFromServer(data.dtend);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
